export const MODULE = 'invoices';
